import * as Yup from 'yup';
export const FormValidationSchema = Yup.object().shape({
  title: Yup.string()
    .required('Judul harus di isi')
    .trim('Harus berupa karakter')
    .strict(true),

  shiptos: Yup.mixed().optional(),

  // Accept codes (string[]) or API objects for backward compatibility
  business_types: Yup.array()
    .of(
      Yup.mixed().test(
        'business-type-format',
        'Invalid business type format',
        (value) => {
          if (typeof value === 'string') return true;
          if (
            value &&
            typeof value === 'object' &&
            'cg_3_business_type' in value &&
            'cg_3_business_type_desc' in value
          ) {
            return (
              typeof value.cg_3_business_type === 'string' &&
              typeof value.cg_3_business_type_desc === 'string'
            );
          }
          return false;
        }
      )
    )
    .optional(),
  product_highlight_type: Yup.string()
    .oneOf(['general', 'specific'])
    .optional(),
  type: Yup.string().oneOf(['general', 'specific']).optional(),
});
